(() => {
  'use strict';

  class MetaseryAnatomy extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready === 'true') return;
      this.dataset.ready = 'true';

      this.triggers = [...this.querySelectorAll('[data-anatomy-point]')];
      this.cards = [...this.querySelectorAll('[data-anatomy-card]')];
      if (!this.triggers.length || !this.cards.length) return;

      // Both the dots and the legend rows point at the same card index.
      this.triggers.forEach((trigger) => {
        trigger.addEventListener('click', () => {
          const index = trigger.dataset.anatomyPoint;
          this.open(this.active === index ? null : index);
        });
      });

      // Hover is a desktop convenience only; touch devices would fire it on tap
      // and fight the click handler.
      if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
        this.querySelectorAll('.anatomy__point').forEach((point) => {
          point.addEventListener('pointerenter', () => this.open(point.dataset.anatomyPoint));
        });
      }

      this.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && this.active !== null) {
          event.stopPropagation();
          const current = this.triggers.find((t) => t.dataset.anatomyPoint === this.active);
          this.open(null);
          current?.focus();
        }
      });

      // No close-on-outside-click: this is an annotation, not a modal. Leaving the
      // last point selected means the section always shows something, and a stray
      // click elsewhere on the page does not wipe the reader's place.
      this.active = null;
      if (this.dataset.openFirst === 'true') this.open('0');
    }

    open(index) {
      this.active = index;
      this.cards.forEach((card) => {
        const match = card.dataset.anatomyCard === index;
        card.hidden = !match;
        card.classList.toggle('is-open', match);
      });
      this.triggers.forEach((trigger) => {
        trigger.setAttribute('aria-expanded', String(trigger.dataset.anatomyPoint === index));
      });
    }
  }

  if (!customElements.get('metasery-anatomy')) customElements.define('metasery-anatomy', MetaseryAnatomy);
})();
